import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {CommonResponse} from "../../../response/common.response";
import {UtilityService} from "../../utility.service";


@Injectable({
    providedIn: 'root'
})
export class ApiUploadRepository {
    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;
    PUBLIC_URI = environment.PUBLIC_URI;

    // tslint:disable-next-line:max-line-length
    constructor(private http: HttpClient, private utilityService: UtilityService) {
    }




    // @ts-ignore
    public async uploadFileServe(file: FormData): Promise<CommonResponse> {
        try {
            // tslint:disable-next-line:max-line-length
            const responseSuccess = await this.http.post(this.API_URI + 'upload/uploadFileServe', file).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            await this.utilityService.parseData(responseError);
        }
    }







}
